import React from 'react';
import { Link, Redirect, useParams, useRouteMatch } from 'react-router-dom';
import MetaSetting from 'components/atom/MetaSetting';
import { Content } from '../lib/FL';
import ContentPreview from '../components/contents/ContentPreview';

import styles from './ContentSamplePage.module.scss';

type Props = {
  contentsData: Content[];
};

const ContentSamplePage: React.FC<Props> = ({ contentsData }) => {
  document.documentElement.className = 'contentSample';

  const detailMatch = useRouteMatch('/content/:enName/detail/:device?');
  const isDetail = detailMatch !== null;

  type ParamProps = {
    enName: string;
    device?: string;
  };
  const { enName, device = '' } = useParams<ParamProps>();

  const targetContent = contentsData.find((contentData) => contentData.en_name === enName);
  if (targetContent === undefined) {
    return <Redirect to='/' />;
  }

  if (device === 'pc' || device === 'sp') {
    return (
      <main className={styles.content}>
        <div className={`${styles.noResponsive}`} data-device={device}>
          <ContentPreview contentEnName={enName} device={device} isDetail={isDetail} />
        </div>
      </main>
    );
  }

  const hasDetailPage = targetContent.icons.includes('cms_detail') || targetContent.en_name === 'list';

  return (
    <>
      <MetaSetting title={`${targetContent.ja_name}｜ホームページ制作 コンテンツサンプル`} isNoIndex />
      <main className={styles.content}>
        <div className={styles.pcOnly}>
          <ContentPreview contentEnName={enName} device='pc' isDetail={isDetail} />
        </div>
        <div className={styles.spOnly}>
          <ContentPreview contentEnName={enName} device='sp' isDetail={isDetail} />
        </div>
        {hasDetailPage && (
          <div className={styles.listDetailSwitch}>
            <Link to={`/content/${enName}${isDetail ? '' : '/detail'}`} className={styles.listDetailSwitch__button}>
              {isDetail ? '一覧' : '詳細'}を見る
            </Link>
          </div>
        )}
      </main>
    </>
  );
};
export default ContentSamplePage;
